// In production, we register a service worker to serve assets from local cache.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.

import Scriba from 'react-scriba';
import { Immocom } from './specifique/immocom';

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === '[::1]' ||
  // 127.0.0.1/8 is considered localhost for IPv4.
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

var isSubscribed;

export default function register() {
    if ('serviceWorker' in navigator) {//process.env.NODE_ENV === 'production' && 
        // The URL constructor is available in all browsers that support SW.
        const publicUrl = new URL(process.env.PUBLIC_URL, window.location);
        if (publicUrl.origin !== window.location.origin) {
            // Our service worker won't work if PUBLIC_URL is on a different origin
            // from what our page is served on. This might happen if a CDN is used to
            // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
            return;
        }

        window.addEventListener('load', () => {
            const swUrl = `${process.env.PUBLIC_URL}/Eiffimmo-service-worker.js`;

            if (isLocalhost) {
                // This is running on localhost. Lets check if a service worker still exists or not.
                checkValidServiceWorker(swUrl);
            } else {
                // Is not local host. Just register service worker
                registerServiceWorker(swUrl);
            }

            askPermission();
        });
    }
}
/*********************** NEW ****************************/
function registerServiceWorker(swUrl) {
    return navigator.serviceWorker.register(swUrl)
        .then(function (registration) {
            console.log('Service worker successfully registered.');
            return registration;
        })
        .catch(function (err) {
            console.error('Unable to register service worker.', err);
        });
}
function askPermission() {
    return new Promise(function (resolve, reject) {
        const permissionResult = Notification.requestPermission(function (result) {
            resolve(result);
        });

        if (permissionResult) {
            permissionResult.then(resolve, reject);
        }
    })
        .then(function (permissionResult) {
            if (permissionResult !== 'granted') {
                console.log('We weren\'t granted permission.');
            }
            else {
                console.log('We were granted permission.');
            }
        });
}
/***********************************************************/

function registerValidSW(swUrl) {
    navigator.serviceWorker
        .register(swUrl)
        .then(registration => {

            //registration.onupdatefound = () => {
            const installingWorker = registration.installing;

            // Set the initial subscription value
            registration.pushManager.getSubscription()
                .then(function (subscription) {
                    isSubscribed = !(subscription === null);

                    if (isSubscribed) {
                        console.log('User IS subscribed.');
                        //console.log(JSON.stringify(subscription));

                        var endpoint = JSON.parse(JSON.stringify(subscription)).endpoint;
                        var auth = JSON.parse(JSON.stringify(subscription)).keys.auth;
                        var p256dh = JSON.parse(JSON.stringify(subscription)).keys.p256dh;

                        let objet = {
                            "endpoint": endpoint,
                            "auth": auth,
                            "p256dh": p256dh
                        };
                        var url = "api/Devices/Create";
                        var paramPost = Scriba.fetch().createParameterPost(objet);

                        fetch(url, paramPost)
                            .then(response => response.json())
                            .then(responseFetch => {
                                //let retourVerif = responseFetch.d;
                                if (responseFetch.reponseAPIobjet !== null) {
                                    let objetData = responseFetch.reponseAPIobjet;
                                    if (objetData == "OK") {
                                        console.log("Enregistrement du endpoint termin�.");
                                    }
                                    else {
                                        console.log(objetData);
                                    }
                                }
                                else {
                                    console.log('erreur');
                                    //Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                                }
                            });
                    } else {
                        console.log('User is NOT subscribed.');
                        //subscribeUser();
                        subscribeUserToPush();
                    }
                });

            //  installingWorker.onstatechange = () => {
            //    if (installingWorker.state === 'installed') {
            //      if (navigator.serviceWorker.controller) {
            //        // At this point, the old content will have been purged and
            //        // the fresh content will have been added to the cache.
            //        // It's the perfect time to display a "New content is
            //        // available; please refresh." message in your web app.
            //        //console.log('New content is available; please refresh.');
            //      } else {
            //        // At this point, everything has been precached.
            //        // It's the perfect time to display a
            //        // "Content is cached for offline use." message.
            //        //console.log('Content is cached for offline use.');
            //      }
            //    }
            //  //};
            //};
        })
        .catch(error => {
            console.error('Error during service worker registration:', error);
        });
}

function checkValidServiceWorker (swUrl) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl)
    .then(response => {
      // Ensure service worker exists, and that we really are getting a JS file.
      if (
        response.status === 404 ||
        response.headers.get('content-type').indexOf('javascript') === -1
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl);
      }
    })
    .catch(() => {
      console.log(
        'No internet connection found. App is running in offline mode.'
      );
    });
}

export function unregister () {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
}


//function subscribeUser() {
//    const applicationServerPublicKey = 'BCgYaJA2-JBB1_Cumf4vrYnpPbz6DpkjkShIrQo2xs7SmvymrHrir_9-beErTnU2toVW3UcEchCKoFpp0-zBHpQ';
//    const applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);

//    swRegistration.pushManager.subscribe({
//        userVisibleOnly: true,
//        applicationServerKey: applicationServerKey
//    })
//        .then(function (subscription) {
//            console.log('User is subscribed.');

//            //updateSubscriptionOnServer(subscription);

//            isSubscribed = true;
//        })
//        .catch(function (err) {
//            console.log('Failed to subscribe the user: ', err);
//        });
//}
//function updateSubscriptionOnServer(subscription) {
//    // TODO: Send subscription to application server

//    //const subscriptionJson = document.querySelector('.js-subscription-json');
//    //const subscriptionDetails = document.querySelector('.js-subscription-details');

//    //if (subscription) {
//    //    subscriptionJson.textContent = JSON.stringify(subscription);
//    //    subscriptionDetails.classList.remove('is-invisible');
//    //} else {
//    //    subscriptionDetails.classList.add('is-invisible');
//    //}
//}
function urlB64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}


export function addSubscribeUserToPush () {
    subscribeUserToPush();
}

function subscribeUserToPush() {
    const applicationServerPublicKey = 'BCgYaJA2-JBB1_Cumf4vrYnpPbz6DpkjkShIrQo2xs7SmvymrHrir_9-beErTnU2toVW3UcEchCKoFpp0-zBHpQ';
    const applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);

    return navigator.serviceWorker
        .register('/Eiffimmo-service-worker.js')
        .then(function (registration) {
            const subscribeOptions = {
                userVisibleOnly: true,
                applicationServerKey: applicationServerKey
            };
            if (isLocalhost)
                return null
            else
                return registration.pushManager.subscribe(subscribeOptions);
        })
        .then(function (pushSubscription) {
            console.log('Received PushSubscription: ', JSON.stringify(pushSubscription));
            return pushSubscription;
        });
}